import classNames from "classnames";
import CiroCard from "../../shared/CiroCard";
import CuratedSearchPromptSection from "./CuratedSearchPromptSection";
import CuratedSearchDesignStepsContainer from "../CuratedSearchDesignSteps/CuratedSearchDesignStepsContainer";
import { useContext } from "react";
import AutopilotCuratedSearchContext from "../../../contexts/AutopilotCuratedSearchContext";
import { AutopilotFilterCreationTypeEnum } from "../../../__generated__/graphql";

const LsnCuratedSearchPromptCard = ({
  initialLoading,
}: {
  initialLoading: boolean;
}) => {
  const { startedGeneratingFilters } = useContext(
    AutopilotCuratedSearchContext,
  );

  return (
    <CiroCard size="small">
      <div className={classNames("flex", "flex-col", "gap-4")}>
        <CuratedSearchPromptSection loading={initialLoading} />
        {startedGeneratingFilters && (
          <CuratedSearchDesignStepsContainer
            searchType={AutopilotFilterCreationTypeEnum.LsnGeneralFilters}
            isLsn={true}
          />
        )}
      </div>
    </CiroCard>
  );
};

export default LsnCuratedSearchPromptCard;
